import * as React from "react"
import { cn } from "@/lib/utils"

interface NeumorphicCardProps extends React.HTMLAttributes<HTMLDivElement> {
  gradientBorder?: boolean
}

const NeumorphicCard = React.forwardRef<HTMLDivElement, NeumorphicCardProps>(
  ({ className, gradientBorder, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "bg-neu-surface shadow-neumorphic rounded-[12px] lg:rounded-[14px] xl:rounded-[16px] 2xl:rounded-[18px] relative",
          gradientBorder && "p-[1px] bg-gradient-to-r from-neu-brand-from to-neu-brand-to",
          className
        )}
        {...props}
      >
        {gradientBorder ? (
          <div className="bg-neu-surface rounded-[11px] lg:rounded-[13px] xl:rounded-[15px] 2xl:rounded-[17px] h-full w-full">
            {children}
          </div>
        ) : (
          children
        )}
      </div>
    )
  }
)
NeumorphicCard.displayName = "NeumorphicCard"

export { NeumorphicCard }
